export default [
    {
        path: '/punto-de-venta',
        component: resolve => require(['./../index.vue'], resolve),
        children: [
            {
                path: '/punto-de-venta/pos',
                component: resolve => require(['../views/point_of_sale/index.vue'], resolve),
                meta: {
                    title: 'Punto de venta',
                    permission: 'Punto de venta'
                }
            },
        ]
    }
];



// WEBPACK FOOTER //
// ./src/point_of_sale/router/index.js